module.exports = new __parcel__URL__("coastal-flooding-and-slr-cover.be877b07.jpg").toString();